var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 39.25,
    height: 39.25,
    rx: 2.625,
    fill: "#F3F4F5",
    stroke: "#DBDAE3",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.543 14.498C30 16.28 30 20 30 20C30 20 30 23.72 29.543 25.502C29.289 26.487 28.546 27.262 27.605 27.524C25.896 28 20 28 20 28C20 28 14.107 28 12.395 27.524C11.45 27.258 10.708 26.484 10.457 25.502C10 23.72 10 20 10 20C10 20 10 16.28 10.457 14.498C10.711 13.513 11.454 12.738 12.395 12.476C14.107 12 20 12 20 12C20 12 25.896 12 27.605 12.476C28.55 12.742 29.292 13.516 29.543 14.498ZM18 23.5L24 20L18 16.5V23.5Z",
    fill: "#7F858B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8e54202938931f0c74f1f4c8699db293.svg";
export { ForwardRef as ReactComponent };